import script from "./EMA.vue?vue&type=script&lang=js"
export * from "./EMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__